/**
 * Hands a file the app fetched to the browser as a download, under a name of its own - for
 * files behind the session (evidence, data exports), which a plain link cannot reach.
 */
export function saveFile(data, name) {
    const url = URL.createObjectURL(data);
    try {
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        link.click();
    }
    finally {
        // After the click has handed the file over; revoking at once can cancel it in some browsers.
        setTimeout(() => URL.revokeObjectURL(url), 10_000);
    }
}
/** Opens a PDF in a tab of its own; where the browser blocks it, saves it instead. */
export function openPdf(blob, name) {
    const url = URL.createObjectURL(blob);
    const opened = window.open(url, '_blank', 'noopener');
    if (!opened)
        saveFile(blob, name);
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
/**
 * Hands a disclosure (Art. 15, 20 GDPR) to the browser as a JSON file, named after the person
 * and the day it was made.
 */
export function saveDisclosure(data, name) {
    const file = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const person = name.replace(/[^\p{L}\p{N}.@-]+/gu, '-');
    saveFile(file, `auskunft-${person}-${data.createdAt.slice(0, 10)}.json`);
}
//# sourceMappingURL=save-file.js.map